function accumulateResults<T>(promise: Promise<T>, results: Array<T> = []): Promise<Array<T>> {
  return promise.then((result: T) => results.concat(result))
}

// Applies array of params to fn sequentially
// so that next params are applied once previous have succeeded
// function fn should return promise
function sequentially<T, R>(params: Array<T>, fn: (param: T) => Promise<R>): Promise<Array<R>> {
  const [first, ...rest] = params

  if (first === undefined) {
    return Promise.resolve([])
  }

  return rest.reduce(
    (promise, param) => promise.then((results) => accumulateResults(fn(param), results)),
    accumulateResults(fn(first))
  )
}

export { accumulateResults, sequentially }
